import * as Sentry from "@sentry/react";
import { FormikHelpers } from "formik";
import { Onboarding } from "sdk/onboardings";
import { useOnboardingUpdateMutation } from "~/store/api";
import { useNav } from "../features/Nav";
import { useOnboarding } from "./useOnboarding";

export const useSubmitOnboardingQuestion = () => {
  const [apiOnboardingUpdate] = useOnboardingUpdateMutation();
  const { handleSetOnboarding } = useOnboarding();
  const { goToNext } = useNav();

  const onSubmit = async (
    values: Partial<Onboarding>,
    formikHelpers: FormikHelpers<any>,
  ) => {
    try {
      const responseBody = await apiOnboardingUpdate(values).unwrap();

      const onboarding = responseBody.data.attributes;
      handleSetOnboarding(onboarding);

      goToNext(onboarding);
    } catch (err: any) {
      const error = err?.data?.error ?? {};
      formikHelpers.setErrors(error);

      Sentry.captureException(err);
    }
  };

  return {
    onSubmit,
  };
};
